import EcoImg from 'eco-design/base/eco-img';
import { SceneEmail } from '@elem/compCommon/SceneEmail';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function A1() {
    const { useLang } = useGlobal();
    const { t } = useLang('outdoorrecreation');

    return (
        <div className={`outdoor-recreation-A1 ${css['outdoor-recreation-A1']}`}>
            <EcoImg
                pc="https://websiteoss.ecoflow.com/figma-uploads/1786948368921-zc4xrq-compressed-001.webp"
                h5="https://websiteoss.ecoflow.com/figma-uploads/1786948322532-1jln7o-compressed-001.webp"
                alt={t('secA_title')}
                aria-label={t('secA_title')}
            />
            <div className="info">
                <p className="title">{t('secA_title')}</p>
                <p className="desc">{t('secA_desc')}</p>
                <SceneEmail theme="white" type="OUTDOOR_RECRATION" title={t('secA_title')} defaultChecked={false} />
            </div>
        </div>
    );
}
